import { BaseComponent } from 'src/app/_core/tools/base.component';
import { ChangeDetectorRef, Directive, OnInit } from '@angular/core';
import { HomeState, SubNotificationType } from 'src/app/_shared/stores/home/home.state';
import { HomeNotification, ListeHomeNotification } from 'src/graphql/generated-types';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
    HomeCloseNotificationAction,
    HomeSetSubNotificationTypeAction
} from 'src/app/_shared/stores/home/home.actions';

export enum SharedNotificationsTypes {
    Beneficiary = 'BENEFICIARY',
    WebAdministration = 'WEB_ADMINISTRATION',
    Sales = 'SALES',
    Accounting = 'ACCOUNTING',
    Benefits = 'PRESTATIONS',
    Savings = 'EPARGNES',
    MediaLibraries = 'MEDIATHEQUE',
    SharedResources = 'SHARED_RESOURCES'
}

export type SharedNotification = HomeNotification;

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class SharedNotifications<T> extends BaseComponent implements OnInit {

    @Select(HomeState.selectedNotification) selectedNotification$: Observable<ListeHomeNotification>;

    notificationsList: SharedNotification[] = [];

    selectedNotification: ListeHomeNotification = null;

    constructor(protected readonly cdr: ChangeDetectorRef) {
        super(cdr);
    }

    closeNotification(): void {
        this.dispatch$(new HomeCloseNotificationAction());
    }

    countItems(type: T): number {
        return this.notificationsList.find(e => e.Type === '' + type)?.Count || 0;
    }

    protected setNotificationType(notificationType: SubNotificationType): Observable<any> {
        return this.dispatch$(new HomeSetSubNotificationTypeAction(notificationType));
    }

    ngOnInit(): void {
        this.watch$ = this.selectedNotification$.pipe(
            tap(selectedNotification => {
                this.selectedNotification = selectedNotification;
                this.notificationsList = selectedNotification?.ListeNotifications?.BaseHomeNotification || [];
                this.cdr.markForCheck();
            })
        );
    }

}
